import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav>
      <ul className="nav-links">
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/posts">What I'm reading</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;